import React, { useCallback, useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FooterSimple from "./components/FooterSimple";
import Home from "./pages/Home";
import HandiCrafts from "./pages/HandiCrafts";
import OurStory from "./pages/OurStory";
import OurBrand from "./pages/OurBrand";
import ContactUs from "./pages/ContactUs";
import GalleryPage from "./pages/GalleryPage";
import RequestQuote from "./pages/RequestQuote";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgressBar from "./components/ScrollProgressBar";
import ScrollToTopButton from "./components/ScrollToTopButton";
import SplashScreen from "./components/SplashScreen";
import ScrollReveal from "./components/ScrollReveal";
import TextReveal from "./components/TextReveal";

function SiteFooter() {
  const { pathname } = useLocation();
  return pathname === "/request-quote" ? <FooterSimple /> : <Footer />;
}

function AnimatedRoutes() {
  const location = useLocation();
  const isFlushTop = location.pathname === "/";
  // || location.pathname === "/our-brand";

  return (
    <main className={isFlushTop ? "tp-main--flush" : undefined}>
      <div key={location.pathname} className="tp-page-transition">
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/handicrafts" element={<HandiCrafts />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/our-brand" element={<OurBrand />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/request-quote" element={<RequestQuote />} />
        </Routes>
      </div>
    </main>
  );
}

// Watches the route and tells App whenever a navigation just happened.
// Keeps the latest onNavigate in a ref so the effect only needs to
// depend on the path — this is what stops the loop.
// function RouteWatcher({ onNavigate }) {
//   const location = useLocation();
//   const isFirstRender = useRef(true);
//   const onNavigateRef = useRef(onNavigate);
//   onNavigateRef.current = onNavigate;

//   useEffect(() => {
//     if (isFirstRender.current) {
//       isFirstRender.current = false;
//       return; // initial load is handled by showSplash's default state
//     }
//     onNavigateRef.current();
//   }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

//   return null;
// }
const SPLASH_SESSION_KEY = "tp-splash-shown";

function App() {
  const [showSplash, setShowSplash] = useState(
    () => sessionStorage.getItem(SPLASH_SESSION_KEY) !== "true",
  );

  const handleSplashFinish = () => {
    sessionStorage.setItem(SPLASH_SESSION_KEY, "true");
    setShowSplash(false);
  };

  // const [showSplash, setShowSplash] = useState(true);
  // const handleSplashFinish = useCallback(() => setShowSplash(false), []);
  // const handleNavigate = useCallback(() => setShowSplash(true), []);

  return (
    <BrowserRouter>
      {/* <RouteWatcher onNavigate={handleNavigate} /> */}
      {showSplash && <SplashScreen onFinish={handleSplashFinish} />}
      <div className="tp-app" aria-hidden={showSplash}>
        <ScrollProgressBar />
        <ScrollReveal />
        <TextReveal />
        <ScrollToTop />
        <ScrollToTopButton />
        <Navbar />
        <AnimatedRoutes />
        <SiteFooter />
      </div>
    </BrowserRouter>
  );
}

export default App;
